<template>
  <div class="searchExams__empty-cart">
    <div class="searchExams__empty-cart--icon">
      <CartSvg />
    </div>
    <p class="searchExams__empty-cart--title">Seu carrinho está vazio!</p>
    <p class="searchExams__empty-cart--subtitle">
      Adicione pelo menos 1 exame para continuar com o Check-in.
    </p>
  </div>
</template>

<script>
export default {
  name: 'EmptyCartPartial',
};
</script>

<style lang="scss">
.searchExams {
  &__empty-cart {
    padding: 40px 36px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;

    &--icon {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 72px;
      height: 72px;
      border-radius: 50%;
      background-color: #e6ebff;
    }

    &--title {
      font-weight: 700;
      font-size:16px;
      line-height: 120%;
      color: #292929;
      padding-top: 24px;
    }

    &--subtitle {
      font-size: 14px;
      line-height: 150%;
      color: #363636;
    }
  }
}
</style>
